import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AssessmentStatusBadgeComponent } from '@leads/shared/components/assessment-status-badge/assessment-status-badge.component';
import { LeadRequestType } from '@leads/shared/models/domain/lead-request.domain';
import { ILeadAssessmentWithLeadRequest } from '@leads/shared/models/firebase/scheduled-assessment.model';
import { dateTimeRange } from '@shared/classes/datetime.utils';
import { LinkLocationComponent } from '@shared/components/buttons/link-location/link-location.component';

@Component({
	selector: 'app-schedule-card',
	imports: [CommonModule, LinkLocationComponent, AssessmentStatusBadgeComponent],
	templateUrl: './schedule-card.component.html',
	styleUrl: './schedule-card.component.scss',
})
export class ScheduleCardComponent {
	@Input() assessment: ILeadAssessmentWithLeadRequest;

	LeadRequestType = LeadRequestType;

	get assessmentDateTime(): string {
		return dateTimeRange(this.assessment.assignment.dateTime.start.toDate(), this.assessment.assignment.dateTime.end.toDate());
	}
}
